
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconPencilSelector = "fhi-icon-pencil";

/**
 * ## FhiIconPencil
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-pencil
 * @element fhi-icon-pencil
 */
@customElement(FhiIconPencilSelector)
export class FhiIconPencil extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M19.182 1.25a3.57 3.57 0 0 1 2.644 5.965l-.122.128-2.1 2.1a1 1 0 0 1-.074.087 1 1 0 0 1-.09.075L8.359 20.691l-.001.001a2.75 2.75 0 0 1-.982.63l-.16.054-4.354 1.32H2.86a1.25 1.25 0 0 1-1.556-1.554v-.003l1.321-4.353.001-.002a2.75 2.75 0 0 1 .688-1.14L14.396 4.556a.8.8 0 0 1 .159-.159l2.102-2.102a3.57 3.57 0 0 1 2.525-1.045M4.372 16.705a1.25 1.25 0 0 0-.313.517l-1.185 3.902 3.904-1.184c.196-.06.375-.166.52-.31L17.933 8.993l-2.926-2.926zM19.182 2.75a2.07 2.07 0 0 0-1.463.605l-1.652 1.652 2.926 2.926 1.65-1.65a2.07 2.07 0 0 0-1.461-3.533"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
